import { LineStyle } from "./lcharts/src/renderers/draw-line";
import { RetracementTypes } from '../Services/dg-hub-client.service';
import { ExtensionType } from "./lcharts/src/model/series-options";





export class RetracementSettings
{

  public numberOfRows = 25;
  public defaultLevels:DefaultLevels;
  public fibonnaciLevels:number[] = [0, 0.236,	0.382, 0.5, 0.618, 0.786, 1];

  //[0, 0.236,	0.382, 0.5, 0.618, 0.786, 1];

  public constructor()
  {
    this.defaultLevels = new DefaultLevels();
    this.defaultLevels.upwave = [];
    this.defaultLevels.downwave = [];

    for(var i=0;i<this.numberOfRows;i++)
    {

      let row:IRetracementSettingsRow = { id:i,
                  levelValue:(i<this.fibonnaciLevels.length)?this.fibonnaciLevels[i]:null,
                  color:"#ffffff",
                  isExtended:false,
                  width:1,
                  style:LineStyle.Solid,
                  extensionType:ExtensionType.None
                };

      this.defaultLevels.upwave.push(row)
      this.defaultLevels.downwave.push(row)
    }


  }


  public getDefaultLevels()
  {
    let defaultVal: IRetracementSettingsRow[]=[];

    for(var i=0;i<this.numberOfRows;i++)
    {

      let row:IRetracementSettingsRow = { id:i,
                  levelValue:(i<this.fibonnaciLevels.length)?this.fibonnaciLevels[i]:null,
                  color:"#ffffff",
                  isExtended:false,
                  width:1,
                  style:LineStyle.Solid,
                  extensionType:ExtensionType.None
                };
                defaultVal.push(row);
    }
    return defaultVal;
  }

  public currentLevels(type:RetracementTypes):IRetracementSettingsRow[]
  {
    switch(type)
    {
      case RetracementTypes.UPWAVE:
      return this.defaultLevels.upwave;

      case RetracementTypes.DOWNWAVE:
      return this.defaultLevels.downwave;

    }

  }

  public updateLevels(levelsUp:IRetracementSettingsRow[], levelsDown:IRetracementSettingsRow[])
  {
    if(levelsUp)
    this.defaultLevels.upwave = levelsUp;

    if(levelsDown)
    this.defaultLevels.downwave = levelsDown;
  }

}

export interface IRetracementSettingsRow
{
  id:number;
  levelValue:number;
  color:string;
  isExtended:boolean;
  extensionType:ExtensionType
  width:number;
  style:LineStyle
}

export interface lineSettings
{
  color:string,
  lineStyle:LineStyle,
  lineWidth:number,
  extendedStyle:LineStyle
}

export interface IRetracementSettingsRowsSet
{
  name:string;
  levels: IRetracementSettingsRow[]
  type:RetracementTypes
}

export class DefaultLevels
{
  upwave:IRetracementSettingsRow[];
  downwave:IRetracementSettingsRow[];
}

export class ExtensionTypesWithLabel
{
  public extensionWitLabels:ExtensionWithLabel[]=
  [
    {label:"None", extension:ExtensionType.None},
    {label:"Right", extension:ExtensionType.Right},
    {label:"Left", extension:ExtensionType.Left},
    {label:"Both", extension:ExtensionType.Both},
  ]
}

export class ExtensionWithLabel
{
  public extension:ExtensionType
  public label:string
}
